import React, { useContext, useMemo, useCallback } from 'react'
import { CheckBox, Text } from '@usap/uicomponents'
import seoIDs from '../../../config/seoIds'
import { GTM } from '../../helpers'
import { LocalContext } from '../../helpers/useLocalContext'
import { SearchContext } from '../common/context/SearchContextProvider'

const showUniversalFitBox = false
const productFit = 'false'
const universalFilter = 'filters[universal]'
const defaultUniversalValue = ''
const itemPerPage = 'itemperpage'
const defaultPageItems = 15
const currentPage = 'currentpage'
const defaultCurrentPage = '1'

export default function UniversalCheckboxComponent(props) {
  const { toggleItemsPerPage } = props
  const {
    searchState: { products },
  } = useContext(SearchContext)
  const {
    resultCount: numberOfProducts = 0,
    allDirectFit,
    allUniversal,
  } = products
  const { localContext } = useContext(LocalContext)
  const { history } = localContext
  const urlParams = new URLSearchParams(
    __BROWSER__ ? window.location.search : history.location.pathname,
  )
  const universal = urlParams.get(universalFilter) || defaultUniversalValue
  const pageItemsCount = Number(urlParams.get(itemPerPage) || defaultPageItems)
  const pageNumber = Number(urlParams.get(currentPage) || defaultCurrentPage)
  const hasMinNumberOfProducts = pageItemsCount > numberOfProducts
  const shownRecords = hasMinNumberOfProducts
    ? numberOfProducts
    : pageItemsCount
  const { searchResultsTabView } = GTM
  const isChecked = useMemo(() => {
    if (allDirectFit) return false
    if (allUniversal) return true
    return universal !== productFit
  }, [allDirectFit, allUniversal, universal])

  const isDisabled = useMemo(() => {
    if (allDirectFit || allUniversal) return true
    return false
  }, [allDirectFit, allUniversal])

  const handleOnChange = useCallback(
    () => {
      const universalChange = universal === productFit

      const categories = universalChange
        ? 'Show all products'
        : 'Show universal-fit products only'

      searchResultsTabView({
        searchResultsCount: numberOfProducts,
        categories,
        itemsPerPageSelection: shownRecords,
        resultPageNumberSelection: pageNumber,
        clickText: 'Show universal-fit products',
      })

      toggleItemsPerPage('filters[universal]', productFit, universalChange)
    },
    [universal,
      searchResultsTabView,
      toggleItemsPerPage,
      numberOfProducts,
      shownRecords,
      pageNumber],
  )

  return showUniversalFitBox ? (
    <CheckBox
      id={seoIDs.universalCheckBox}
      checked={isChecked}
      disabled={isDisabled}
      onChange={() => {
        handleOnChange()
      }}
      label={<Text size="small">Include universal-fit products</Text>}
    />
  )
    : ''
}
